export default __webpack_public_path__ + "assets/75acdc417bfab1b199471eb80e2509fc.png";